import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";

import BaseService from "./base.service";

export default class AiCheckKnowledgeService extends BaseService {
  getList = () => {
    return this.axios.get(API_ENDPOINTS.AI_CHECK_KNOWLEDGE_DB_LIST);
  };
}
